import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { TitlingServiceConfigSchema } from '../configurations/TitlingServiceConfig.js';
import { servicesProviderGenericDataSchema, agentSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderTitlingDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.TITLING]: TitlingServiceConfigSchema,
    }),
    agents: z.array(agentSchema),
});

export { servicesProviderTitlingDataSchema };
//# sourceMappingURL=ServicesProviderTitlingData.js.map
